/* eslint-disable max-len */

import { createGlobalStyle } from 'styled-components';
import * as Colors from './alluvium-colors';
import {
  alluviumBranding,
  lightBg,
  lightest,
  pageBg,
  rangePickerInRange,
  focusShadow,
  statusColors,
  successGreen,
  successGreenLight,
  alertErrorDescription,
} from './alluviumTheme';

const {
  primaryColor,
  primaryColorHover,
  primaryColorActive,
  darkAccent,
  goldAccent,
  headerDarkBg,
  tableHeaderColor,
} = alluviumBranding;

export const AlluviumGlobalOverrides = createGlobalStyle`
  .alluvium-theme {
    background-color: ${pageBg};
  }

  .alluvium-theme .app-header a:hover,
  .alluvium-theme .app-header a:focus {
    color: ${Colors.primary400};
    border-bottom-color: ${Colors.primary400};
  }

  .alluvium-theme .ant-btn {
    border-radius: 0 !important;
  }

  .alluvium-theme .ant-btn-primary {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: ${Colors.white};
  }

  .alluvium-theme .ant-btn-primary:hover,
  .alluvium-theme .ant-btn-primary:focus {
    background-color: ${primaryColorHover};
    border-color: ${primaryColorHover};
    color: #fff;
  }

  .alluvium-theme .ant-btn-primary:active {
    background-color: ${primaryColorActive};
    border-color: ${primaryColorActive};
    color: #fff;
  }

  // light-button
  .alluvium-theme .ant-btn:not(.ant-btn-primary):not(.ant-btn-dashed):not(.ant-btn-danger):not(.ant-btn-link):not(.ant-btn-ghost) {
    color: ${Colors.neutral550} !important;
    background-color: ${Colors.ink25};
    border: 1px solid ${Colors.ink75};
  }

  .alluvium-theme .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):hover,
  .alluvium-theme .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):focus {
    color: ${Colors.neutral550} !important;
    background-color: ${Colors.ink50};
    border-color: ${Colors.ink100};
  }

  .alluvium-theme .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):active {
    color: ${primaryColorActive};
    border-color: ${primaryColorActive};
  }

  .alluvium-theme .ant-btn-link {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-btn-link:hover,
  .alluvium-theme .ant-btn-link:focus {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-btn-link:active {
    color: ${primaryColorActive};
  }

  .alluvium-theme .time-btn:not(.dash-btn),
  .alluvium-theme .show-more-button {
    background-color: ${Colors.ink600} !important;
    border-color: ${Colors.ink600} !important;
  }

  .alluvium-theme .time-btn.ant-btn-link {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .alluvium-theme .dash-btn {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .alluvium-theme a {
    color: ${Colors.ink600};
  }

  .alluvium-theme a:hover,
  .alluvium-theme a:focus {
    color: ${Colors.ink300};
  }

  .alluvium-theme .ant-page-header-back-button:hover,
  .alluvium-theme .ant-page-header-back-button:focus {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-spin-dot-item {
    background-color: ${primaryColor};
  }

  .alluvium-theme .ant-page-header {
    background: #fff;
  }

  .alluvium-theme .ant-divider {
    border-top-color: ${lightest};
  }

  .alluvium-theme .ant-card {
    border-color: ${lightest};
  }

  .alluvium-theme .ant-dropdown-menu-item > a:hover,
  .alluvium-theme .ant-breadcrumb a:hover,
  .alluvium-theme .ant-table-row a:hover,
  .alluvium-theme .ant-list-item a:hover,
  .alluvium-theme .ant-card a:hover,
  .alluvium-theme .ant-menu-item a:hover {
    color: ${Colors.ink300};
  }

  .alluvium-theme .ant-table-tbody > tr > td {
    background: ${Colors.ink25};
  }

  .alluvium-theme .ant-table-tbody > tr:nth-child(even) > td {
    background: ${Colors.ink50};
  }

  .alluvium-theme .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
  .alluvium-theme .ant-table-tbody >
    tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: ${Colors.ink75} !important;
  }

  .alluvium-theme .ant-table-thead > tr > th {
    background: ${Colors.primary700};
    border-bottom-color: ${Colors.ink100};
    color: ${tableHeaderColor};
  }

  .alluvium-theme .ant-table-tbody > tr > td {
    border-bottom-color: ${Colors.ink100};
  }

  .alluvium-theme .ant-table-bordered .ant-table-thead > tr > th,
  .alluvium-theme .ant-table-bordered .ant-table-tbody > tr > td {
    border-right-color: ${lightest};
  }

  .alluvium-theme .ant-table {
    border-color: ${lightest};
  }

  .alluvium-theme .ant-table-bordered {
    border-color: ${lightest};
  }

  .alluvium-theme .ant-table-thead > tr > th.ant-table-column-sort {
    color: ${Colors.white};
    font-weight: 700;
  }

  .alluvium-theme .ant-table-thead > tr > th .ant-table-column-sorter-up.on,
  .alluvium-theme .ant-table-thead > tr > th .ant-table-column-sorter-down.on,
  :root .alluvium-theme .ant-table-thead > tr > th .ant-table-column-sorter-up.on,
  :root .alluvium-theme .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
    color: ${Colors.white};
    font-weight: 700;
  }

  .alluvium-theme .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
    background: ${darkAccent};
  }

  .alluvium-theme .ant-table-thead > tr > th .anticon-filter {
    color: ${tableHeaderColor};
  }

  .alluvium-theme .ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
    color: ${Colors.white};
  }

  .alluvium-theme .ant-pagination-item-active {
    border-color: ${primaryColor};
  }

  .alluvium-theme .ant-pagination-item-active a {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-pagination-item:hover {
    border-color: ${primaryColor};
  }

  .alluvium-theme .ant-pagination-item:hover a {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-pagination-prev:hover .ant-pagination-item-link,
  .alluvium-theme .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${primaryColor};
    color: ${primaryColor};
  }

  .alluvium-theme .ant-switch {
    background-color: ${Colors.ink100};
  }

  .alluvium-theme .ant-switch-checked {
    background-color: ${Colors.ink600};
  }

  .alluvium-theme .ant-checkbox-checked .ant-checkbox-inner,
  .alluvium-theme .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
    background-color: ${Colors.ink600};
    border-color: ${Colors.ink600};
  }

  .alluvium-theme .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
    background-color: ${Colors.ink600};
  }

  .alluvium-theme .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .alluvium-theme .ant-checkbox:hover .ant-checkbox-inner,
  .alluvium-theme .ant-checkbox-checked::after,
  .alluvium-theme .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,
  .alluvium-theme .ant-tree-checkbox:hover .ant-tree-checkbox-inner,
  .alluvium-theme .ant-tree-checkbox-checked::after {
    border-color: ${Colors.ink600};
  }

  .alluvium-theme .ant-radio-checked .ant-radio-inner {
    border-color: ${darkAccent};
  }

  .alluvium-theme .ant-radio-checked .ant-radio-inner::after {
    background-color: ${darkAccent};
  }

  /* Solid radio button group (e.g. Profile Type selector) */
  .alluvium-theme .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: ${darkAccent};
    border-color: ${darkAccent};
    color: #fff;
    box-shadow: -1px 0 0 0 ${darkAccent};
  }
  .alluvium-theme .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    background: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }
  .alluvium-theme .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
    background: ${primaryColorActive};
    border-color: ${primaryColorActive};
    color: #fff;
  }
  .alluvium-theme .ant-radio-button-wrapper:hover {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-tabs-tab {
    color: rgba(0, 0, 0, 0.65);
  }

  .alluvium-theme .ant-tabs-tab:hover {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-tabs-nav .ant-tabs-tab-active,
  .alluvium-theme .ant-tabs-nav .ant-tabs-tab-active:hover {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-tabs-ink-bar {
    background-color: ${primaryColor};
  }

  .alluvium-theme .ant-select-selection {
    border-bottom-color: ${Colors.neutral200} !important;
  }

  .alluvium-theme .ant-select-selection:hover {
    border-bottom-color: ${Colors.ink600} !important;
  }

  .alluvium-theme .ant-select-selection:focus,
  .alluvium-theme .ant-select-selection:active,
  .alluvium-theme .ant-select-focused .ant-select-selection,
  .alluvium-theme .ant-select-open .ant-select-selection {
    border-color: ${Colors.ink600};
    border-bottom-color: ${Colors.ink600} !important;
    border-bottom-width: 1px !important;
  }

  .alluvium-theme .ant-select-selection__placeholder {
    color: ${Colors.neutral300};
  }

  .alluvium-theme .ant-select-dropdown-menu-item-selected,
  .alluvium-theme .ant-select-dropdown-menu-item-selected:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: ${Colors.ink25};
    color: ${Colors.ink600};
    font-weight: 600;
  }

  .alluvium-theme .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),
  .alluvium-theme .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: ${Colors.ink50} !important;
  }

  .alluvium-theme .ant-select-arrow,
  .alluvium-theme .ant-select-arrow .anticon {
    color: ${primaryColor} !important;
  }

  .alluvium-theme .ant-input {
    border-bottom-color: ${lightBg} !important;
  }

  .alluvium-theme .ant-input:focus,
  .alluvium-theme .ant-input:hover {
    border-color: ${primaryColor};
    border-bottom-color: ${primaryColor} !important;
  }

  .alluvium-theme .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),
  .alluvium-theme .ant-input-affix-wrapper .ant-input:focus {
    border-color: ${primaryColor};
    border-bottom-color: ${primaryColor};
  }

  .alluvium-theme .ant-upload.ant-upload-drag .ant-upload-drag-icon .anticon {
    color: ${primaryColor};
  }

  .alluvium-theme .text-blue {
    color: ${goldAccent};
  }

  .alluvium-theme .ant-table-thead .text-blue {
    color: ${Colors.white};
    font-weight: 700;
  }

  .alluvium-theme .btn-blue {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }

  .alluvium-theme .btn-blue:hover {
    background-color: ${primaryColorHover};
    border-color: ${primaryColorHover};
  }

  .alluvium-theme .ant-steps-item-process .ant-steps-item-icon {
    background: ${darkAccent};
    border-color: ${darkAccent};
  }

  .alluvium-theme .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${darkAccent};
  }

  .alluvium-theme .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${darkAccent};
  }

  .alluvium-theme .ant-steps-item-finish .ant-steps-item-title::after,
  .alluvium-theme .ant-steps-item-finish .ant-steps-item-tail::after {
    background-color: ${darkAccent} !important;
  }

  /* Portal-rendered overrides (dropdowns, modals, drawers, popovers render outside .alluvium-theme) */
  /* Safe because this stylesheet only mounts when isAlluvium is true */
  .alluvium-theme .ant-dropdown .ant-btn-primary,
  .alluvium-theme .ant-popover .ant-btn-primary,
  .alluvium-theme .ant-modal .ant-btn-primary,
  .alluvium-theme .ant-drawer .ant-btn-primary,
  .alluvium-theme .ant-picker-dropdown .ant-btn-primary,
  .alluvium-theme .ant-select-dropdown .ant-btn-primary {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: ${Colors.textOnDarkMuted};
  }

  .alluvium-theme .ant-dropdown .ant-btn-primary:hover,
  .alluvium-theme .ant-dropdown .ant-btn-primary:focus,
  .alluvium-theme .ant-popover .ant-btn-primary:hover,
  .alluvium-theme .ant-popover .ant-btn-primary:focus,
  .alluvium-theme .ant-modal .ant-btn-primary:hover,
  .alluvium-theme .ant-modal .ant-btn-primary:focus,
  .alluvium-theme .ant-drawer .ant-btn-primary:hover,
  .alluvium-theme .ant-drawer .ant-btn-primary:focus,
  .alluvium-theme .ant-picker-dropdown .ant-btn-primary:hover,
  .alluvium-theme .ant-picker-dropdown .ant-btn-primary:focus,
  .alluvium-theme .ant-select-dropdown .ant-btn-primary:hover,
  .alluvium-theme .ant-select-dropdown .ant-btn-primary:focus {
    background-color: ${primaryColorHover};
    border-color: ${primaryColorHover};
    color: #fff;
  }

  .alluvium-theme .ant-dropdown .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):hover,
  .alluvium-theme .ant-dropdown .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):focus,
  .alluvium-theme .ant-popover .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):hover,
  .alluvium-theme .ant-popover .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):focus,
  .alluvium-theme .ant-modal .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):hover,
  .alluvium-theme .ant-modal .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):focus,
  .alluvium-theme .ant-drawer .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):hover,
  .alluvium-theme .ant-drawer .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):not(.ant-btn-danger):not(.ant-btn-ghost):focus {
    color: ${primaryColor};
    border-color: ${primaryColor};
  }

  .alluvium-theme .ant-dropdown a:hover,
  .alluvium-theme .ant-popover a:hover,
  .alluvium-theme .ant-modal a:hover,
  .alluvium-theme .ant-drawer a:hover {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-dropdown .ant-btn-link,
  .alluvium-theme .ant-popover .ant-btn-link,
  .alluvium-theme .ant-modal .ant-btn-link,
  .alluvium-theme .ant-drawer .ant-btn-link {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-dropdown .ant-btn-link:hover,
  .alluvium-theme .ant-dropdown .ant-btn-link:focus,
  .alluvium-theme .ant-popover .ant-btn-link:hover,
  .alluvium-theme .ant-popover .ant-btn-link:focus,
  .alluvium-theme .ant-modal .ant-btn-link:hover,
  .alluvium-theme .ant-modal .ant-btn-link:focus,
  .alluvium-theme .ant-drawer .ant-btn-link:hover,
  .alluvium-theme .ant-drawer .ant-btn-link:focus {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled),
  .alluvium-theme .ant-dropdown-menu-item-active:not(.ant-dropdown-menu-item-disabled) {
    background-color: ${lightBg} !important;
  }

  /* Table filter dropdown OK/Reset links (portal-rendered) */
  .alluvium-theme .ant-table-filter-dropdown-link {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-table-filter-dropdown-link:hover {
    color: ${primaryColorHover};
  }

  /* Table filter dropdown checkbox (portal-rendered) */
  .alluvium-theme .ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${darkAccent};
    border-color: ${darkAccent};
  }

  .alluvium-theme .ant-table-filter-dropdown .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .alluvium-theme .ant-table-filter-dropdown .ant-checkbox:hover .ant-checkbox-inner,
  .alluvium-theme .ant-table-filter-dropdown .ant-checkbox-checked::after {
    border-color: ${darkAccent};
  }

  /* Table filter dropdown selected item text */
  .alluvium-theme .ant-table-filter-dropdown .ant-dropdown-menu-item-selected,
  .alluvium-theme .ant-table-filter-dropdown .ant-dropdown-menu-item-selected > a {
    color: ${primaryColor};
    background-color: ${lightBg};
  }

  /* Date/range picker (portal-rendered) */
  .alluvium-theme .ant-calendar a,
  .alluvium-theme .ant-calendar-range a {
    color: ${primaryColor};
  }

  .alluvium-theme .ant-calendar-today .ant-calendar-date {
    border-color: transparent;
    background: transparent;
    font-weight: 700;
    color: inherit;
  }

  .alluvium-theme .ant-calendar-selected-day .ant-calendar-date,
  .alluvium-theme .ant-calendar-selected-date .ant-calendar-date {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }

  .alluvium-theme .ant-calendar-selected-day .ant-calendar-date:hover,
  .alluvium-theme .ant-calendar-selected-date .ant-calendar-date:hover {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }

  .alluvium-theme .ant-calendar-selected-day .ant-calendar-date:focus,
  .alluvium-theme .ant-calendar-selected-day .ant-calendar-date:active,
  .alluvium-theme .ant-calendar-selected-date .ant-calendar-date:focus,
  .alluvium-theme .ant-calendar-selected-date .ant-calendar-date:active,
  .alluvium-theme .ant-calendar-date:focus,
  .alluvium-theme .ant-calendar-date:active {
    border-color: ${primaryColor};
    outline: none;
    box-shadow: none;
  }

  .alluvium-theme .ant-calendar-date:hover {
    background-color: ${lightBg};
  }

  .alluvium-theme .ant-calendar-header a:hover {
    color: ${primaryColorHover};
  }

  .alluvium-theme .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month,
  .alluvium-theme .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
    background-color: ${primaryColor};
    color: #fff;
  }

  .alluvium-theme .ant-calendar-in-range-cell::before {
    background-color: ${lightBg};
  }

  /* Range picker: start/end date cells */
  .alluvium-theme .ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,
  .alluvium-theme .ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }

  .alluvium-theme .ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date:hover,
  .alluvium-theme .ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date:hover {
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    color: #fff;
  }

  /* Range picker: in-range cells background */
  .alluvium-theme .ant-calendar-range .ant-calendar-in-range-cell::before {
    background-color: ${rangePickerInRange};
  }

  /* Range picker: today indicator within range */
  .alluvium-theme .ant-calendar-range .ant-calendar-today .ant-calendar-date {
    border-color: transparent;
    background: transparent;
    font-weight: 700;
    color: inherit;
  }

  /* Input focus borders in date picker */
  .alluvium-theme .ant-calendar-range .ant-calendar-input:focus,
  .alluvium-theme .ant-calendar-input:focus {
    border-color: ${primaryColor};
  }

  /* Date picker wrapper input hover/focus border */
  .alluvium-theme .ant-calendar-picker:hover .ant-input,
  .alluvium-theme .ant-calendar-picker:focus .ant-input,
  .alluvium-theme .ant-calendar-picker-focused .ant-input {
    border-color: ${primaryColor};
  }

  .alluvium-theme .ant-calendar-picker-focused .ant-input {
    box-shadow: 0 0 0 2px ${focusShadow};
  }

  .alluvium-theme .ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled),
  .alluvium-theme .ant-calendar-picker-focused .ant-calendar-picker-input:not(.ant-input-disabled) {
    border-color: ${primaryColor} !important;
    box-shadow: 0 0 0 2px ${focusShadow} !important;
  }

  /* Portal-rendered input hover/focus (dropdowns, popovers, modals) */
  .alluvium-theme .ant-dropdown .ant-input:hover,
  .alluvium-theme .ant-dropdown .ant-input:focus,
  .alluvium-theme .ant-popover .ant-input:hover,
  .alluvium-theme .ant-popover .ant-input:focus,
  .alluvium-theme .ant-modal .ant-input:hover,
  .alluvium-theme .ant-modal .ant-input:focus,
  .alluvium-theme .ant-drawer .ant-input:hover,
  .alluvium-theme .ant-drawer .ant-input:focus {
    border-color: ${primaryColor};
  }

  //.alluvium-theme .ant-dropdown .ant-input:focus,
  //.alluvium-theme .ant-popover .ant-input:focus,
  //.alluvium-theme .ant-modal .ant-input:focus,
  //.alluvium-theme .ant-drawer .ant-input:focus {
  //  box-shadow: 0 0 0 2px ${focusShadow};
  //}

  /* Global input hover/focus override (safe: stylesheet only mounts for alluvium) */
  .alluvium-theme .ant-input:hover,
  .alluvium-theme .ant-input:focus {
    border-color: ${primaryColor} !important;
  }

  //.alluvium-theme .ant-input:focus {
  //  box-shadow: 0 0 0 2px ${focusShadow} !important;
  //}

  /* ============================================
   * WARM-TINTED STATUS TAG COLORS
   * Ant Design <Tag> overrides for brand cohesion.
   * Default tag rule first, colored overrides after.
   * ============================================ */

  /* Default/uncolored tags (Cancelled, etc.) → Warm Gray */
  .alluvium-theme .ant-tag {
    background-color: ${statusColors.default.bg};
    border-color: ${statusColors.default.border};
    border-width: 0.5px;
    color: ${statusColors.default.text};
  }

  /* Blue tags (Booked, Scheduled) → Warm Muted Blue (palette: In Review) */
  .alluvium-theme .ant-tag-blue {
    background-color: ${statusColors.blue.bg};
    border-color: ${statusColors.blue.border};
    color: ${statusColors.blue.text};
  }

  /* Orange tags (Pending, Booking/Proposed) → Warm Gold (palette: Pending) */
  .alluvium-theme .ant-tag-orange {
    background-color: ${statusColors.orange.bg};
    border-color: ${statusColors.orange.border};
    color: ${statusColors.orange.text};
  }

  /* Green tags (Patient Seen, Fulfilled) → Warm Sage (palette: Confirmed) */
  .alluvium-theme .ant-tag-green {
    background-color: ${statusColors.green.bg};
    border-color: ${statusColors.green.border};
    color: ${statusColors.green.text};
  }

  /* Red tags (No Show, Failed, Rejected) → Warm Coral (palette: Cancelled) */
  .alluvium-theme .ant-tag-red {
    background-color: ${statusColors.red.bg};
    border-color: ${statusColors.red.border};
    color: ${statusColors.red.text};
  }

  /* Purple tags (Sent To External WorkQ) → Warm Plum */
  .alluvium-theme .ant-tag-purple {
    background-color: ${statusColors.purple.bg};
    border-color: ${statusColors.purple.border};
    color: ${statusColors.purple.text};
  }

  /* Yellow tags (Accepted) → Warm Amber */
  .alluvium-theme .ant-tag-yellow {
    background-color: ${statusColors.yellow.bg};
    border-color: ${statusColors.yellow.border};
    color: ${statusColors.yellow.text};
  }

  /* ============================================
   * ADDITIONAL ANT DESIGN COMPONENT OVERRIDES
   * Covers remaining components that use
   * @primary-color but weren't previously handled.
   * ============================================ */

  /* Badge */
  .alluvium-theme .ant-badge-status-processing {
    background-color: ${primaryColor};
  }
  .alluvium-theme .ant-badge-count {
    background-color: ${darkAccent};
  }

  /* Progress */
  .alluvium-theme .ant-progress-bg {
    background-color: ${primaryColor};
  }
  .alluvium-theme .ant-progress-status-success .ant-progress-bg {
    background-color: ${successGreen};
  }

  /* Timeline */
  .alluvium-theme .ant-timeline-item-head-blue {
    color: ${primaryColor};
    border-color: ${primaryColor};
  }

  /* Tree */
  .alluvium-theme .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: ${lightBg};
    color: ${primaryColor};
  }
  .alluvium-theme .ant-tree li .ant-tree-node-content-wrapper:hover {
    background-color: ${lightBg};
  }

  /* Menu */
  .alluvium-theme .ant-menu-item-selected,
  .alluvium-theme .ant-menu-item-selected > a,
  .alluvium-theme .ant-menu-item-selected > a:hover {
    color: ${primaryColor};
  }
  .alluvium-theme .ant-menu-item:hover,
  .alluvium-theme .ant-menu-item-active,
  .alluvium-theme .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .alluvium-theme .ant-menu-submenu-active,
  .alluvium-theme .ant-menu-submenu-title:hover {
    color: ${primaryColor};
  }
  .alluvium-theme .ant-menu-horizontal > .ant-menu-item:hover,
  .alluvium-theme .ant-menu-horizontal > .ant-menu-item-active,
  .alluvium-theme .ant-menu-horizontal > .ant-menu-item-selected {
    border-bottom-color: ${primaryColor};
    color: ${primaryColor};
  }
  .alluvium-theme .ant-menu-item::after {
    border-right-color: ${primaryColor};
  }
  .alluvium-theme .ant-menu-vertical .ant-menu-item::after {
    border-right-color: ${primaryColor};
  }

  /* Alert info → Palette blue status */
  .alluvium-theme .ant-alert-info {
    background-color: ${statusColors.blue.bg} !important;
    border-color: ${statusColors.blue.border} !important;
    border-width: 0.5px !important;
  }
  .alluvium-theme .ant-alert-info .ant-alert-icon {
    color: ${statusColors.blue.text} !important;
  }
  .alluvium-theme .ant-alert-info .ant-alert-message {
    color: ${statusColors.blue.text} !important;
  }
  .alluvium-theme .ant-alert-info .ant-alert-description {
    color: ${statusColors.blue.text} !important;
  }

  /* Alert error → Palette red/coral status */
  .alluvium-theme .ant-alert-error {
    background-color: ${statusColors.red.bg} !important;
    border-color: ${statusColors.red.border} !important;
    border-width: 0.5px !important;
  }
  .alluvium-theme .ant-alert-error .ant-alert-icon {
    color: ${statusColors.red.text} !important;
  }
  .alluvium-theme .ant-alert-error .ant-alert-message {
    color: ${statusColors.red.text} !important;
  }
  .alluvium-theme .ant-alert-error .ant-alert-description {
    color: ${alertErrorDescription} !important;
  }

  /* Badge success dot → Palette green/sage status */
  .alluvium-theme .ant-badge-status-success {
    background-color: ${successGreenLight};
  }

  /* Message info */
  .alluvium-theme .ant-message-info .anticon {
    color: ${primaryColor};
  }

  /* Notification */
  .alluvium-theme .ant-notification-notice-icon-info {
    color: ${primaryColor};
  }

  /* Collapse */
  .alluvium-theme .ant-collapse-header:hover,
  .alluvium-theme .ant-collapse-header:focus {
    color: ${primaryColor};
  }

  /* Anchor */
  .alluvium-theme .ant-anchor-link-active > .ant-anchor-link-title {
    color: ${primaryColor};
  }
  .alluvium-theme .ant-anchor-ink-ball {
    border-color: ${primaryColor};
  }

  /* Breadcrumb */
  .alluvium-theme .ant-breadcrumb a:active {
    color: ${primaryColorActive};
  }

  /* Dropdown selected items */
  .alluvium-theme .ant-dropdown-menu-item-selected,
  .alluvium-theme .ant-dropdown-menu-item-selected > a {
    color: ${primaryColor};
    background-color: ${lightBg};
  }

  /* Transfer */
  .alluvium-theme .ant-transfer-list-header-selected span {
    color: ${primaryColor};
  }
  .alluvium-theme .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
    background-color: ${lightBg};
  }

  /* Cascader */
  .alluvium-theme .ant-cascader-menu-item:hover {
    background-color: ${lightBg};
  }
  .alluvium-theme .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled) {
    background-color: ${lightBg};
    font-weight: 600;
  }

  /* Rate (stars) */
  .alluvium-theme .ant-rate-star-full .anticon,
  .alluvium-theme .ant-rate-star-half .ant-rate-star-first .anticon {
    color: ${goldAccent};
  }

  /* Skeleton loading pulse */
  .alluvium-theme .ant-skeleton-content .ant-skeleton-title,
  .alluvium-theme .ant-skeleton-content .ant-skeleton-paragraph > li {
    background: linear-gradient(90deg, ${lightBg} 25%, ${lightest} 37%, ${lightBg} 63%);
    background-size: 400% 100%;
  }

  /* Portal-rendered: Menu items (context menus, etc.) */
  .ant-menu-item-selected,
  .ant-menu-item-selected > a {
    color: ${primaryColor};
  }
  .ant-menu-item:hover,
  .ant-menu-item-active {
    color: ${primaryColor};
  }

  /* Portal-rendered: Badge */
  .ant-badge-status-processing {
    background-color: ${primaryColor};
  }

  /* Portal-rendered: Tree node selection */
  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: ${lightBg};
  }

  /* Links/buttons with hardcoded Blockit blue via styled-component theme */
  .alluvium-theme .new-loc-button {
    color: ${primaryColor};
  }

  /* Portal-rendered: react-modal card header and buttons */
  .card-head {
    background-color: ${headerDarkBg} !important;
  }

  .btn-blue {
    background-color: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
    color: #fff !important;
  }

  .btn-blue:hover {
    background-color: ${primaryColorHover} !important;
    border-color: ${primaryColorHover} !important;
  }

  .alluvium-theme .main-content {
    border: 1px solid ${Colors.ink100};
    background-color: ${Colors.white};
  }

  .alluvium-theme .main-content-padded {
    padding: 0 1rem 1rem 1rem;
  }

  .alluvium-theme .main-content-padded-full {
    padding: 1rem;
  }

  .alluvium-theme .main-content-padded-bottom {
    padding-bottom: 1rem;
  }

  .alluvium-theme .referral-show-content,
  .alluvium-theme .appointment-show-content {
    padding: 0 16px 16px 16px !important;
  }

  .alluvium-theme .has-error .ant-form-explain,
  .alluvium-theme .has-error .ant-form-item-required::before {
    color: ${Colors.coral600};
  }

  .alluvium-theme .ant-table-wrapper {
    background-color: white;
  }

  .alluvium-theme .ant-table-pagination {
    border-bottom-color: ${Colors.ink100};
    margin-right: 24px;
  }

  .alluvium-theme .table-header > .ant-page-header-heading {
    align-items: flex-end;
    display: flex;
  }

  .alluvium-theme .table-card > * > .ant-card-head-wrapper {
    align-items: center;
    display: flex;
  }

  .alluvium-theme .table-header > .ant-page-header-heading > .ant-page-header-heading-title,
  .alluvium-theme .table-card > * > .ant-card-head-wrapper > .ant-card-head-title {
    flex: auto;
  }

  .alluvium-theme .table-header > .ant-page-header-heading > .ant-page-header-heading-extra,
  .alluvium-theme .table-card > * > .ant-card-head-wrapper > .ant-card-extra {
    align-items: center;
    display: flex;
    flex: none;
  }

  .alluvium-theme .main-content > * > .ant-page-header-heading > .ant-page-header-heading-title,
  .alluvium-theme .table-card > * > .ant-card-head-wrapper > div.ant-card-head-title {
    font-size: 18px;
    font-weight: 700;
  }

  .alluvium-theme .main-content > * > .ant-page-header-heading > .ant-page-header-heading-title > * {
    font-weight: 500;
    font-size: revert;
  }

  .alluvium-theme .table-card {
    border-width: 0px;
  }

  .alluvium-theme .table-card > .ant-card-body {
    padding: 0px;
  }

  .alluvium-theme .table-card-search .ant-input {
    border-color: ${Colors.ink600};
    color: ${Colors.ink600};
  }

  .alluvium-theme .table-card-search .ant-input::placeholder {
    color: ${Colors.ink300};
    border-color: ${Colors.ink300};
  }

  .alluvium-theme .table-card-search .ant-input:focus {
    border-bottom-width: 1px !important;
    box-shadow: none !important;
  }

  .alluvium-theme .form-card {
    border-width: 0px;
  }

  .alluvium-theme .form-card > .ant-card-body {
    padding: 0px;
  }

  .alluvium-theme .ant-form label {
    color: ${Colors.neutral600};
  }

  .alluvium-theme .out-of-order-wrapper {
    position: relative;
  }

  .alluvium-theme .out-of-order-search {
    background-color: white;
    position: absolute;
    right: 24px;
    top: 16px;
    z-index: 1;
  }

  .alluvium-theme .out-of-order-main > .ant-tabs-bar {
    padding: 4px 24px 16px;
    background-color: white;
    margin-bottom: 0px;
  }

  .alluvium-theme .out-of-order-main div.ant-tabs-tab {
    font-weight: 700;
  }

  .alluvium-theme .date-box {
    border-color: ${Colors.ink600} !important;

    & p {
      background-color: ${Colors.ink600} !important;
    }
  }
`;
